// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__3OBIG","header":"Layout_header__1V-LV","headerimg":"Layout_headerimg__21BDy","textcont":"Layout_textcont__1OLwy"};